import fetch from 'cross-fetch'

export const checkStatusCode = async (response) => {
  if (response.status >= 200 && response.status < 400) {
    return response
  }

  const contentType = response.headers.get('content-type')
  if (contentType && contentType.includes('application/json')) {
    const { error } = await response.json()

    let errorMessage
    if (typeof error === 'string') {
      errorMessage = error
    } else {
      errorMessage = error.title
      if (error.detail) {
        errorMessage += `: ${error.detail}`
      }
    }

    throw new Error(errorMessage)
  }

  throw new Error(response.status)
}

export const makeRequest = async ({ url, requestOptions }) => {
  let response = await fetch(url, requestOptions)

  response = await checkStatusCode(response)
  const contentType = response.headers.get('content-type')

  if (contentType && contentType.includes('application/json')) {
    return response.json()
  }
  return {}
}
